import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Mountain } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PROFESSIONS } from "@/lib/constants";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Onboarding() {
    const { user, refresh } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: user?.name || "", phone: "", company: "", crea: "", profession: "",
    });
    const [saving, setSaving] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!form.profession) { toast.error("Selecione sua profissão."); return; }
        setSaving(true);
        try {
            await api.put("/auth/profile", form);
            await refresh();
            toast.success("Perfil concluído!");
            navigate("/dashboard");
        } catch (e) {
            toast.error("Erro ao salvar perfil.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 topo-texture p-6">
            <div className="w-full max-w-lg bg-white border border-slate-200 rounded-xl shadow-sm p-8">
                <div className="flex items-center gap-2 font-heading font-black text-lg text-petroleum mb-2">
                    <Mountain className="w-6 h-6 text-mineral" /> GEOMINE MANAGER
                </div>
                <h1 className="font-heading text-2xl font-black text-slate-900">Complete seu perfil</h1>
                <p className="text-slate-500 mt-1 text-sm">Precisamos de alguns dados profissionais para personalizar sua experiência.</p>
                <form onSubmit={submit} className="mt-6 space-y-4">
                    <div>
                        <Label className="mb-1.5 block">Nome completo</Label>
                        <Input data-testid="onboarding-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
                    </div>
                    <div className="grid sm:grid-cols-2 gap-4">
                        <div>
                            <Label className="mb-1.5 block">Telefone</Label>
                            <Input data-testid="onboarding-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="(00) 00000-0000" />
                        </div>
                        <div>
                            <Label className="mb-1.5 block">Empresa</Label>
                            <Input data-testid="onboarding-company" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} />
                        </div>
                    </div>
                    <div className="grid sm:grid-cols-2 gap-4">
                        <div>
                            <Label className="mb-1.5 block">CREA (opcional)</Label>
                            <Input data-testid="onboarding-crea" value={form.crea} onChange={(e) => setForm({ ...form, crea: e.target.value })} />
                        </div>
                        <div>
                            <Label className="mb-1.5 block">Profissão</Label>
                            <Select value={form.profession} onValueChange={(v) => setForm({ ...form, profession: v })}>
                                <SelectTrigger data-testid="onboarding-profession"><SelectValue placeholder="Selecione" /></SelectTrigger>
                                <SelectContent>
                                    {PROFESSIONS.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                    <button type="submit" disabled={saving} data-testid="onboarding-submit"
                        className="w-full bg-petroleum hover:bg-petroleumHover text-white rounded-sm py-3 font-semibold transition-colors disabled:opacity-60">
                        {saving ? "Salvando..." : "Concluir e acessar"}
                    </button>
                </form>
            </div>
        </div>
    );
}
